module.exports = __webpack_public_path__ + "img/serveItem1.4e9fb64e.png";